module.exports = __webpack_public_path__ + "img/DHP Logo no text.415e27d2.png";